export default "__VITE_ASSET__e8fc4ab2__"